/**
 * Form steps
 * Modal to display
 */
export enum PeopleSurveyRequestStep {
    RequestForm,
    RecordListPrbOnly,
    SendMethods
}
